import * as React from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface ProjectLink {
  postId: string;
  postTitle: string;
}

export function useProjectLink(slug: string): { link: ProjectLink | null; loading: boolean } {
  const [link, setLink] = React.useState<ProjectLink | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    getDoc(doc(db, 'projectLinks', slug))
      .then(snap => {
        if (cancelled) return;
        if (snap.exists()) {
          const data = snap.data();
          setLink({ postId: data.postId, postTitle: data.postTitle });
        } else {
          setLink(null);
        }
      })
      .catch(() => { if (!cancelled) setLink(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [slug]);

  return { link, loading };
}
